import Vue from 'vue'
import Vuex from 'vuex'

import boards from './modules/boards'
import prefs from './modules/prefs'
import soon from './modules/soon'
import userdata from './modules/userdata'
import weeks from './modules/weeks'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  modules: {
    boards,
    prefs,
    soon,
    userdata,
    weeks,
  },
  state: {

  },
  mutations: {

  },
  actions: {

  }
})
